<template>
    <div id="reservation" >
      <van-cell-group v-if="type == 1" >
        <van-field
          @click="showPickerShangHai = true"
          :readonly="readonly"
          v-model="area.name"
          rows="1"
          autosize
          label="所在区域（必填）"
          type="textarea"
          placeholder="点击选择"
          input-align="right"></van-field>
        <van-field
          class="wx-label"
          :readonly="readonly"
          @click="showDateTimePicker = true"
          v-model="beginTime"
          rows="1"
          autosize
          label="开赛日期（必填）"
          type="textarea"
          placeholder="点击选择"
          input-align="right"></van-field>
        <van-field
          v-model="gameCount"
          rows="1"
          autosize
          label="场次（必填）"
          type="number"
          placeholder="输入场次"
          input-align="right"></van-field>
        <van-field
          v-model="mobile"
          rows="1"
          autosize
          label="联系电话（必填）"
          type="number"
          :error-message="rulePhone"
          placeholder="输入号码"
          error-message-align="right"
          @blur="rulePhoneEvent"
          @input="rulePhoneEvent"
          input-align="right"></van-field>
        <div class="van-fileld-wx" >
          <van-field
            v-model="wx"
            rows="1"
            autosize
            label="微信"
            type="textarea"
            placeholder="优先通过微信与您联系"
            input-align="right">
            <div slot="button" @click="wx = mobile" style="color: #35B5FF;" >带入手机号</div>
          </van-field>
        </div>
        <div class="line" ></div>
        <textarea cols="30" rows="10" placeholder="请输入备注" class="textarea" v-model="remark" ></textarea>
      </van-cell-group>

      <div v-if="type == 2" class="match-reservation" >
        <van-cell-group>
          <van-field
            @click="showPicker = true"
            :readonly="readonly"
            v-model="area.name"
            rows="1"
            autosize
            label="所在区域（必填）"
            type="textarea"
            placeholder="点击选择"
            input-align="right"></van-field>
          <van-field
            @click="showDateTimePicker = true"
            v-model="beginTime"
            :readonly="readonly"
            rows="1"
            autosize
            label="开赛日期（必填）"
            type="textarea"
            placeholder="点击选择"
            input-align="right"></van-field>
          <van-field
            v-model="mobile"
            rows="1"
            autosize
            label="联系电话（必填）"
            type="number"
            placeholder="输入电话"
            @blur="rulePhoneEvent"
            @input="rulePhoneEvent"
            :error-message="rulePhone"
            error-message-align="right"
            input-align="right"></van-field>
          <div class="van-fileld-wx" >
            <van-field
              v-model="wx"
              rows="1"
              autosize
              label="微信"
              type="textarea"
              placeholder="优先通过微信与您联系"
              input-align="right">
              <div slot="button" @click="wx = mobile" style="color: #35B5FF;" >带入手机号</div>
            </van-field>
          </div>
          <div class="line" ></div>
          <div>
            <h3>您需要服务（可多选 ）</h3>
            <div class="line" ></div>
            <div>
              <van-checkbox-group v-model="result">
                <van-checkbox name="视频拍摄">视频拍摄</van-checkbox>
                <van-checkbox name="比赛解说">比赛解说</van-checkbox>
                <van-checkbox name="赛事上线及数据">赛事上线及数据</van-checkbox>
                <van-checkbox name="赛事内容运营">赛事内容运营</van-checkbox>
                <van-checkbox name="裁判">裁判</van-checkbox>
                <van-checkbox name="赛事执行/策划">赛事执行/策划</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <textarea cols="30" rows="10" placeholder="请输入备注" class="textarea" v-model="remark" ></textarea>
        </van-cell-group>
      </div>

      <div v-if="type == 3" class="match-reservation" >
        <van-cell-group>
          <van-field
            @click="showPicker = true"
            :readonly="readonly"
            v-model="area.name"
            rows="1"
            autosize
            label="所在区域（必填）"
            type="textarea"
            placeholder="点击选择"
            input-align="right"></van-field>
          <van-field
            v-model="mobile"
            rows="1"
            autosize
            label="联系电话（必填）"
            type="number"
            placeholder="输入号码"
            @blur="rulePhoneEvent"
            @input="rulePhoneEvent"
            :error-message="rulePhone"
            error-message-align="right"
            input-align="right">
          </van-field>
          <div class="van-fileld-wx" >
            <van-field
              v-model="wx"
              rows="1"
              autosize
              label="微信"
              type="textarea"
              placeholder="优先通过微信与您联系"
              input-align="right">
              <div slot="button" @click="wx = mobile" style="color: #35B5FF;" >带入手机号</div>
            </van-field>
          </div>
          <div class="line" ></div>
          <div>
            <h3>您的机构类型</h3>
            <div class="line" ></div>
            <div>
              <van-radio-group v-model="radio">
                <van-radio name="赛事服务公司">赛事服务公司</van-radio>
                <van-radio name="个人/个体公司">个人/个体公司</van-radio>
                <van-radio name="体育协会">体育协会</van-radio>
                <van-radio name="体育培训公司">体育培训公司</van-radio>
                <van-radio name="体育场馆">体育场馆</van-radio>
                <van-radio name="俱乐部球队">俱乐部球队</van-radio>
                <van-radio name="学校">学校 </van-radio>
              </van-radio-group>
            </div>
          </div>
          <div>
            <div class="line" ></div>
            <h3>您需要服务（可多选）</h3>
            <div class="line" ></div>
            <div>
              <van-checkbox-group v-model="result">
                <van-checkbox name="办赛工具">办赛工具</van-checkbox>
                <van-checkbox name="视频直播">视频直播</van-checkbox>
                <van-checkbox name="青训管理">青训管理</van-checkbox>
                <van-checkbox name="运动保险">运动保险</van-checkbox>
                <van-checkbox name="装备定制">装备定制</van-checkbox>
                <van-checkbox name="协会系统">协会系统</van-checkbox>
                <van-checkbox name="场馆系统">场馆系统</van-checkbox>
                <van-checkbox name="VIP俱乐部服务">VIP俱乐部服务</van-checkbox>
                <van-checkbox name="邦少年直播">邦少年直播</van-checkbox>
                <van-checkbox name="AI运动相机">AI运动相机</van-checkbox>
                <van-checkbox name="赛事周边定制">赛事周边定制</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <textarea name="" id="" cols="30" rows="10" placeholder="请输入备注" class="textarea" v-model="remark" ></textarea>
        </van-cell-group>
      </div>
      <div style="height: 103px; width: 100%" ></div>
      <div class="submit-wrapper" @click="addBMVideoServiceOrder" >
        <p>提交预约后我们将在一个工作日内与您联系。</p>
        <div class="submit" >提交预约</div>
      </div>

      <!-- 地区-省市 -->
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          value-key="name"
          show-toolbar
          :columns="areas"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        ></van-picker>
      </van-popup>

      <!-- 地区-区县 -->
      <van-popup v-model="showPickerShangHai" position="bottom">
        <van-picker
          value-key="name"
          show-toolbar
          :columns="areaShangHai"
          @cancel="showPickerShangHai = false"
          @confirm="onConfirm"
        ></van-picker>
      </van-popup>

      <!-- 时间 -->
      <van-popup v-model="showDateTimePicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          @cancel="showDateTimePicker = false"
          @confirm="onConfirmDateTime"></van-datetime-picker>
      </van-popup>
      <div class="online-advisory" @click="goAgent()">
        <img src="@/assets/images/human-services.png" >
      </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Moment from 'moment'
import { ImageFormat } from '@/utils'
import { AppType } from '@/utils/index'
import { setTitle } from '@/libs/ds-bridge'
import { addBMVideoServiceOrder, getAreaList } from '@/api/match'
import { Field, Checkbox, CheckboxGroup, Picker, Popup, DatetimePicker, Toast } from 'vant'
Vue.use(Field).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(DatetimePicker).use(Toast)
export default {
  data() {
    return {
      message: null,
      type: null,
      radio: '赛事服务公司',
      area: {},
      areas: [],
      areaShangHai: [],
      result: ['办赛工具'],
      queryParams: {},
      showPicker: false,
      showPickerShangHai: false,
      readonly: true,
      showDateTimePicker: false,
      currentDate: new Date(),
      beginDate: null,
      beginTime: null,
      gameCount: null,
      mobile: null,
      wx: null,
      remark: null,
      rulePhone: ''
    }
  },
  created() {
    this.getAreaList()
    this.getAreaShangHaiList()
    this.shareData = {
      title: '斑马赛事通，人人都能用得起的智能体育直播工具',
      link: window.location.href,
      image: ImageFormat.squareImageView('FoKGFlZjttio9HG_TfoBBXBnQLl3', 120),
      abstract: '设备简单无门槛，包装专业秒杀普通直播，智能记录、自动生成精彩集锦'
    }
    this.wxShare(this.shareData)
  },
  mounted() {
    this.queryParams = this.$route.query
    if (this.queryParams.result) {
      this.result = [this.queryParams.result]
    }
    this.type = this.queryParams.type
    if (this.queryParams.radio) {
      this.radio = this.queryParams.radio
    }
    if (!this.type) {
      Toast('页面错误')
    }
    if (AppType.isInApp()) {
      if (this.type === 1) {
        setTitle('拍摄服务预约')
      } else if (this.type === 2) {
        setTitle('赛事服务预约')
      } else if (this.type === 3) {
        setTitle('申请合作')
      }
    }
  },
  methods: {
    getAreaList() {
      getAreaList(1).then(response => {
        this.areas = response.data.area
        if (this.type == 2) {
          this.areas.shift()
        }
      })
    },
    getAreaShangHaiList() {
      getAreaList(5643).then(response => {
        this.areaShangHai = response.data.area
      })
    },
    onConfirm(value) {
      this.showPicker = false
      this.showPickerShangHai = false
      this.area = value
    },
    onConfirmDateTime(value) {
      this.beginDate = Moment(value).format('YYYY-MM-DDThh:mm:ssZZ')
      this.beginTime = Moment(value).format('YYYY-MM-DD')
      this.showDateTimePicker = false
    },
    addBMVideoServiceOrder() {
      let service = parseInt(this.type) - 1
      let params = {}
      if (service == 0) {
        if (!this.area.id || !this.beginDate || !this.gameCount || !this.mobile) {
          Toast('请填写必选项')
          return
        }
        this.gameCount = this.gameCount
      } else if (service == 1) {
        if (!this.area.id || !this.beginDate || !this.mobile) {
          Toast('请填写必选项')
          return
        }
      } else if (service == 2) {
        if (!this.area.id || !this.mobile) {
          Toast('请填写必选项')
          return
        }
      }
      if (this.rulePhone) {
        Toast('请填写正确的手机号')
        return
      }
      params = {
        service: service,
        areaId: this.area.id,
        beginDate: this.beginDate,
        mobile: this.mobile,
        wx: this.wx,
        remark: this.remark,
        option: this.result.join(','),
        type: this.radio
      }
      addBMVideoServiceOrder(params).then(response => {
        if (response) {
          Toast('预约成功，工作人员将在一个工作日内联系您')
        }
      })
    },
    rulePhoneEvent() {
      if (!(/^\d{11}$/.test(this.mobile))) {
        this.rulePhone = '手机号格式错误'
      } else {
        this.rulePhone = ''
      }
    },
    goAgent() {
      this.$router.push({path: '/customer-service/bd-agent'})
    }
  }
}
</script>

<style lang="stylus">
#reservation
  .van-cell-group
    .van-cell
      .van-cell__title
        max-width 140px
      .van-cell__value
        font-size 12px
    .textarea
      background-color #F9F9F9
      font-size:11px;
      font-weight:400;
      color: black;
      border: none;
      width calc(100% - 50px)
      margin: 15px;
      padding: 10px;
  .submit-wrapper
      width 100 vw
      position fixed
      bottom 0
      left: 0
      background: white;
    .submit
      height:55px;
      line-height 55px;
      text-align center
      background: #E7454D;
      font-size:16px;
      font-weight:500;
      color:rgba(255,255,255,1);
    p
      font-size:14px;
      font-weight:400;
      color:rgba(170,170,170,1);
      line-height:20px;
      text-align center
  .match-reservation
    .van-checkbox-group, .van-radio-group
      display flex
      flex-wrap wrap
      padding: 10px
      .van-checkbox, .van-radio
        padding: 5px;
        font-size:12px;
        font-weight:400;
        color:rgba(102,102,102,1);
  .match-reservation
    h3
      font-size:14px;
      font-weight:400;
      color:rgba(102,102,102,1);
      padding: 0 15px;
    .line
      width calc(100vw - 30px)
      height:2px
      background-color #F8F8F8
      margin auto;
    .van-hairline--top-bottom::after
      border-width 0px;
  .van-fileld-wx
    position relative
    .van-cell
      .van-cell__title
        width 60px
        max-width 60px
      .van-cell__value
        width: calc(100% - 60px);
  .online-advisory
    position: fixed;
    bottom:80px;
    right:8px;
    /*background: url("../images/client-chat.png") center no-repeat;*/
    /*background: url("/assets/images/human-services.png") center no-repeat;*/
    /*background-color:#cc3232;*/
    -webkit-background-size: cover;
    /*background-size: 70%;*/
    width:95px;
    height:46px;
    border-radius:37px;
    img
      width 100%

</style>



// WEBPACK FOOTER //
// src/pages/reservation/index.vue